// Local translations
export const T = {
  en_GB: {
    displayOptions: "Display Options",
    displayDesc: "Choose what information to display with the forecast chart",
    showStatistics: "Show Statistics",
    statisticsDesc: "Display expected return and volatility percentages",
    showTable: "Show Table",
    tableDesc: "Display lower, expected, and upper value projections",
  },
  nb_NO: {
    displayOptions: "Visningsalternativer",
    displayDesc: "Velg hvilken informasjon som skal vises med prognosediagrammet",
    showStatistics: "Vis statistikk",
    statisticsDesc: "Vis forventet avkastning og volatilitetsprosenter",
    showTable: "Vis tabell",
    tableDesc: "Vis lavere, forventet og øvre verdiprojeksjoner",
  },
} as const;
